module.exports = __webpack_public_path__ + "static/media/TEXTILES.1df38467.png";